import { render } from "./ConhecimentoVideos.vue?vue&type=template&id=78f14a40"
import script from "./ConhecimentoVideos.vue?vue&type=script&lang=js"
export * from "./ConhecimentoVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__